import vSelect from 'vue-select';
import './_tooltips';

const { getcookie, optimizely, Vue } = window;

Vue.component('v-select', vSelect);
/*
****** NOTE: Switch back to these options after 10% quarterly and annual plans are ready ******
 options: [
  { id: 0,
    label: 'Month to month',
    val: 1,
    billed: 'monthly' },
  { id: 1,
    label: '3-month prepaid',
    val: 0.90,
    billed: 'quarterly (save 10%)' },
  { id: 2,
    label: 'Annual prepaid',
    val: 0.80,
    billed: 'annually (save 20%)' }
],
**************************************
*/
window.planCost = new Vue({
  el: '#main',
  data: {
    test: false,
    checkCount: 0,
    isStoreOwner: false,
    showDisclaimer: false,
    options: [
      { id: 0,
        label: 'Month to month',
        val: 1,
        billed: 'monthly' },
      { id: 1,
        label: '3-month prepaid',
        val: 0.90,
        billed: 'quarterly' }
    ],
    personal: {
      cost: 29,
      link: [
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_DTLyjtcmWbOVKf',
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_EqjgWK2wpIGnNZ'
      ],
      selected: ''
    },
    professional: {
      cost: 79,
      link: [
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_DTeJsSf8gMNfes',
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_EqjdV4bokJKyMv'
      ],
      selected: ''
    },
    startup: {
      cost: 179,
      link: [
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_ErSxGJNohEKXOr',
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_ErTTHjSh3ZlJjd'
      ],
      selected: ''
    },
    business: {
      cost: 299,
      link: [
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_DTeMjr7wKnPtyi',
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_EqjZ4CwuVx1Tja'
      ],
      selected: ''
    },
    businessTest: {
      cost: 299,
      link: [
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_ErSuRlMx1UCmb3',
        'https://admin.volusion.com/checkout?returnUrl=http://www.volusion.com/pricing/&planId=plan_ErTSHEmbHhRugF'
      ],
      selected: ''
    }

  },
  filters: {
    round(value) {
      return Math.round(value);
    }
  },
  methods: {
    defaultSelected() {
      [
        this.personal,
        this.professional,
        this.startup,
        this.business,
        this.businessTest
      ].map((el) => {
        // eslint-disable-next-line prefer-destructuring
        return el.selected = this.options[1];
      });
    },
    tooltips() {
      jQuery('.tooltip2').tooltip2({
        delay: 5000,
        html: true,
        clickToOpen: true
      });
    },
    carousel() {
      jQuery('.card-carousel').slick({
        lazyLoad: 'progressive',
        adaptiveHeight: true,
        arrows: false,
        asNavFor: '.carousel-nav',
        infinite: false,
        initialSlide: 0,
        variableWidth: false
      });

      jQuery('.carousel-nav').slick({
        arrows: false,
        asNavFor: '.card-carousel',
        centerMode: false,
        draggable: false,
        focusOnSelect: true,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 4,
        swipe: false,
        variableWidth: false
      });
    },
    smoothScroll() {
      jQuery('.scrollspy').scrollSpy({
        scrollOffset: 0
      });
    },
    init() {
      this.tooltips();
      this.carousel();
      this.smoothScroll();
    },
    waitForEl() {
      this.checkCount++;
      if (this.test === false || optimizely === undefined) {
        if (this.checkCount >= 3) {
          this.test = 'original';
          return;
        }
        setTimeout(() => {
          this.waitForEl();
        }, 1000);
      }
    }
  },
  mounted() {
    this.init();
  },
  created() {
    this.defaultSelected();
    this.isStoreOwner = (getcookie('pv1') || getcookie('pv2'));
  },
  beforeMount() {
    this.waitForEl();
  }
});
